export const appConfig = {
  id: process.env.REACT_APP_APP_ID || 'default',
  name: process.env.REACT_APP_APP_NAME || 'Encrypted Chat',
  tagline: process.env.REACT_APP_APP_TAGLINE || 'Quantum-secure messaging node',
  colors: {
    accent: process.env.REACT_APP_APP_ACCENT || '#667eea',
    accentAlt:
      process.env.REACT_APP_APP_ACCENT_ALT ||
      process.env.REACT_APP_APP_ACCENT ||
      '#764ba2',
  },
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api',
  keycloak: {
    // Production Keycloak at auth.quantumemotion.com
    url: process.env.REACT_APP_KEYCLOAK_URL || 'https://auth.quantumemotion.com',
    realm: process.env.REACT_APP_KEYCLOAK_REALM || 'QeM',
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'qem-chat-frontend-demo1',
  },
  pollingIntervalMs: Number(
    process.env.REACT_APP_POLLING_INTERVAL_MS || 15000
  ),
};

export type AppConfig = typeof appConfig;

